<form #noteForm="ngForm">
  <h2 mat-dialog-title class="mat-h2">
    Delete Company
    <button mat-icon-button class="close-button" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <div class="row">
      <div class="col-md-12">
        <h3><b>Company to Delete: {{ deletedCompany?.name }}</b></h3>
        <mat-label class="mat-label">Please select an alternate company to which all projects and associated records will be transferred before above company is deleted</mat-label>
        <mat-form-field appearance="outline" class="mat-form-field-width">
          <mat-select disableOptionCentering [(ngModel)]="selectedCompanyId" name="companyId" required placeholder="Select">
            @for (company of companies; track company) {
              <mat-option [value]="company.id">
                {{ company.companyNumber }} - {{ company.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <mat-divider></mat-divider>

  @if (userService?.roleCheck(['Admin'])) {
    <mat-dialog-actions align="end">
      <button mat-raised-button (click)="closeDialog()">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="noteForm.invalid" (click)="deleteCompany()">
        DELETE
      </button>
    </mat-dialog-actions>
  }
</form>